import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import { CONFIG } from '../common/config';
import LocaleHelper from './core/helpers/locale-helper';
i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
    lng: LocaleHelper.getCurrentLocale(),
    backend: {
        /* translation file path */
        loadPath: '/assets/i18n/{{ns}}/{{lng}}.json?v=1697749986?v8',
    },
    fallbackLng: CONFIG.LOCALES.DEFAULT,
    debug: false,
    /* can have multiple namespace, in case you want to divide a huge translation into smaller pieces and load them on demand */
    ns: ['translations'],
    defaultNS: 'translations',
    nsSeparator: false,
    keySeparator: false,
    interpolation: {
        escapeValue: false,
        formatSeparator: ',',
    },
    react: {
        wait: true,
    },
});
export default i18n;
